import React from 'react';
import SharingSetupModal from '../SharingSetupModal';
import type { SharingSetupProps } from '../types';
import { dealInjectableFields } from './injectableFields';
import defaultShareFormYaml from './default_share_form.yaml?raw';

/**
 * Deal share-message form editor: the shared shell seeded with the deal
 * form.
 */
const SharingSetup: React.FC<SharingSetupProps> = props => (
  <SharingSetupModal
    {...props}
    defaultShareFormYaml={defaultShareFormYaml}
    injectableFields={dealInjectableFields}
  />
);

export default SharingSetup;
